<template>
  <vxe-toolbar class-name="px-8px">
    <template #buttons>
      <DropdownCustom ref="assetsParamsDropdown" button class="h-btn-primary" trigger="click" @click.stop="$refs.assetsParamsDropdown.show()">
        <div>{{ manba(params.entryDate).format('YYYY年MM月') }}</div>
        <template #content>
          <Form style="padding: 10px">
            <FormItem class="!pb-5px" label="会计期间">
              <Select :datas="checkDataList" v-model="params.entryDate" :deletable="false"/>
            </FormItem>
            <FormItem class="!pb-5px" label="增加日期">
              <div class="flex items-center">
                <DatePicker v-model="params.start" :option="{end:params.end}"/>
                <span class="mx-8px">至</span>
                <DatePicker v-model="params.end" :option="{start:params.start}"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px" label="状态">
              <Select :datas="{1:'正常',2:'停用',3:'出租',4:'已减少'}" filterable v-model.number="params.status"/>
            </FormItem>
            <FormItem class="!pb-5px" label="资产编号">
              <Input v-model="params.code"/>
            </FormItem>
            <FormItem class="!pb-5px" label="资产类别">
              <Select :datas="assetsTypeList" keyName="id" titleName="name" filterable v-model.id="params.assetsTypeId"/>
            </FormItem>
            <FormItem class="!pb-5px" label="资产名称">
              <Input v-model="params.name"/>
            </FormItem>
            <FormItem class="!pb-5px" label="规格型号">
              <Input v-model="params.specification"/>
            </FormItem>
            <FormItem class="!pb-5px" label="使用部门">
              <Select :datas="deptList" filterable v-model.id="params.deptId"/>
            </FormItem>
            <FormItem class="!pb-5px" label="供应商">
              <Input v-model="params.supplier"/>
            </FormItem>
            <FormItem class="!pb-5px">
              <vxe-button status="primary" @click="loadList();" :loading="loading">确定</vxe-button>
              <vxe-button @click="this.$refs.assetsParamsDropdown.hide()">取消</vxe-button>
              <vxe-button @click="reset">重置</vxe-button>
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
    </template>
    <template #tools>
      <div style="margin-right: 8px;height: 28px;display: flex;align-items: center;">
        <Checkbox v-model="showAll">显示更多信息</Checkbox>
      </div>
      <vxe-button @click="loadList();initSelect();" status="primary" icon="fa fa-history">刷新</vxe-button>
      <vxe-button @click="showForm()" status="primary" icon="fa fa-plus">添加资产</vxe-button>
      <vxe-button @click="copyAssets()" icon="fa fa-copy">复制资产</vxe-button>
      <vxe-button @click="removeCheckbox()" icon="fa fa-trash">删除资产</vxe-button>
      <vxe-button @click="exportAssets" icon="fa fa-upload">导入</vxe-button>
      <vxe-button @click="exportAssetsOut" icon="fa fa-download">导出</vxe-button>
      <vxe-button @click="printList" icon="fa fa-print">打印列表</vxe-button>
      <vxe-button @click="printCard" icon="fa fa-print">打印卡片</vxe-button>
      <!--      <vxe-button @click="importAssets" icon="fa fa-download">导出</vxe-button>-->
    </template>
  </vxe-toolbar>
  <div class="flex-1">
    <vxe-table height="auto" ref="xTable" border :loading="loading" show-overflow stripe :data="dataList">
      <vxe-column type="checkbox" width="50" align="center" fixed="left"/>
      <vxe-column title="编码" field="code" width="100"/>
      <vxe-column title="资产类别" field="assetsTypeName" width="150"/>
      <vxe-column title="资产名称" field="name" width="200"/>
      <vxe-column v-if="showAll" field="deptName" title="使用部门" width="200" />
      <vxe-column v-if="showAll" field="supplier" title="供应商" width="200" />
      <vxe-column title="规格型号" field="specification" width="100"/>
      <vxe-column title="开始使用日期" field="startDate" width="110"/>
      <vxe-column title="资产原值" field="originalValue" width="130" align="right" formatter="toMoney"/>
      <vxe-column title="本期折旧" field="currentDepreciation" width="130" align="right" formatter="toMoney"/>
      <vxe-column title="资产净值" field="netValue" width="130" align="right" formatter="toMoney"/>
      <vxe-column v-if="showAll" field="addTypeVal" title="增加方式" width="200" />
      <vxe-column title="操作" align="center" width="200" fixed="right">
        <template #default="{row}">
          <div class="actions">
            <span style="vertical-align: middle;" @click="showForm(row)">编辑</span>
            <span style="vertical-align: middle;" @click="showChangeForm(row)" v-if="!row.disposeType && !row.canEdit">变更</span>
            <DropdownMenu
                v-if="!row.disposeType && !row.canEdit"
                class="mr-10px"
                :datas="{'SELL':'出售','SCRAP':'报废','OTHER':'其他'}"
                :toggle-icon="false"
                class-name="h-text-dropdown"
                placement="left-start"
                @clickItem="dispose($event,row)"
            >
              <span>处置</span>
            </DropdownMenu>
            <span style="vertical-align: middle;" @click="showDetail(row)">查看</span>
            <span style="vertical-align: middle;" @click="remove(row)" v-if="row.canEdit">删除</span>
          </div>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
  <vxe-pager @page-change="onPageChange"
             v-model:current-page="pagination.page"
             v-model:page-size="pagination.pageSize"
             :total="pagination.total"
             :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
    <template #left>
      <vxe-button @click="loadList()" type="text" size="mini" icon="fa fa-refresh" :loading="loading"></vxe-button>
    </template>
  </vxe-pager>
  <!-- 固定资产卡片打印 -->
  <div style="height: 0;width: 0;overflow: hidden;">
    <div id="printMec">
      <div style="display: flex; width: 100%;background-color: aqua;flex-wrap: wrap;">
        <table style="page-break-inside: avoid;border: 1px solid #000;margin: 10px;" v-for="(item,index) in checkedRecords">
          <tr>
            <td colspan="2" style="border: 1px solid #000;text-align: center;padding: 4px;">固定资产标识卡</td>
          </tr>
          <tr>
              <td style="border: 1px solid #000;width: 110px;padding: 4px;text-align: center;">资产编码</td>
              <td style="border: 1px solid #000;width: 210px;padding: 4px;text-align: center;">{{ item.code }}</td>
          </tr>
          <tr>
              <td style="border: 1px solid #000;width: 110px;padding: 4px;text-align: center;">资产名称</td>
              <td style="border: 1px solid #000;width: 210px;padding: 4px;text-align: center;">{{ item.name }}</td>
          </tr>
          <tr>
              <td style="border: 1px solid #000;width: 110px;padding: 4px;text-align: center;">规格型号</td>
              <td style="border: 1px solid #000;width: 210px;padding: 4px;text-align: center;">{{ item.specification }}</td>
          </tr>
          <tr>
              <td style="border: 1px solid #000;width: 110px;padding: 4px;text-align: center;">使用部门</td>
              <td style="border: 1px solid #000;width: 210px;padding: 4px;text-align: center;">{{ item.deptName }}</td>
          </tr>
          <tr>
              <td style="border: 1px solid #000;width: 110px;padding: 4px;text-align: center;">使用时间</td>
              <td style="border: 1px solid #000;width: 210px;padding: 4px;text-align: center;">{{ item.startDate }}</td>
          </tr>
        </table>
      </div>
      <Modal v-model="opened">
        <div style="border-bottom: 1px solid #000;padding-bottom: 10px;margin-bottom: 10px;">固定资产卡片打印</div>
        <div style="margin-top: 20px;margin-bottom: 20px;">是否开始打印，共选中{{ openedText }}条固定资产卡片！</div>
        <div style="margin-top:20px;text-align: right;">
          <button class="h-btn" @click="opened=false">取消</button>
          <button v-print="'#printMec'" class="h-btn" @click="opened=false">开始打印</button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import {layer} from "@layui/layer-vue";
import {h} from "vue";
import {padStart} from "xe-utils";
import Assets from "@/api/Assets";
import AssetsForm from "@/views/assets/AssetsForm";
import AssetsChangeForm from "@/views/assets/AssetsChangeForm";
import setting from "@/api/setting";
import Setting from "@/api/setting";
import {mapGetters, mapState} from "vuex";
import AssetsType from "@/api/AssetsType";
import {confirm, message} from "heyui.ext";
import AssetsView from "@/views/assets/AssetsView";
import AssetsImport from "@/views/assets/AssetsImport";

export default {
  name: "AssetsList",
  data() {
    return {
      openedText:'',
      opened: false,
      params: {
        entryDate: null,
        start: null,
        end: null,
        code: null,
        name: null,
        specification: null,
        assetsTypeId: null,
        deptId: null,
        supplier: null,
      },
      loading: false,
      showAll: false,
      checkDataList: [],
      checkedRecords: [], // 用于存储选中的记录  
      dataList: [],
      deptList: [],
      supplierList: [],
      assetsTypeList: [],
      subjectList: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['checkoutSelect']),
    nextCode() {
      return padStart((this.pagination.total + 1) + "", 3, '0')
    },
    deptListMap() {
      let map = {};
      this.deptList.map(val => {
        map[val.key] = val.title;
      })
      return map;
    },
    subjectMap() {
      let map = {};
      this.subjectList.map(val => {
        map[val.code] = val.name;
      })
      return map;
    }
  },
  methods: {
     //jxd导出
     exportAssetsOut () {
      let $table = this.$refs.xTable;
      this.loading = true
      Assets.list(Object.assign({}, this.params, { page: 1, pageSize: 1000000 })).then(({data}) => {
        let processedData = data.results;
        //定义需要导出的列，排除复选框列
        let exportColumns = [
          { field: 'code'},
          { field: 'assetsTypeName'},
          { field: 'name'},
          { field: 'specification'},
          { field: 'startDate'},
          { field: 'originalValue'},
          { field: 'currentDepreciation'},
          { field: 'netValue'},
        ];
        if(this.showAll){
          exportColumns = [
            { field: 'code'},
            { field: 'assetsTypeName'},
            { field: 'name'},
            { field: 'deptName'},
            { field: 'supplier'},
            { field: 'specification'},
            { field: 'startDate'},
            { field: 'originalValue'},
            { field: 'currentDepreciation'},
            { field: 'netValue'},
            { field: 'addTypeVal'},
          ];
        }
        $table.exportData({
          filename: `固定资产列表`,
          type: 'csv',
          isHeader: true,
          isFooter: true,
          data: processedData,
          columns: exportColumns,
        });
      }).finally(() => this.loading = false)
    },
    printCard(){
      this.checkedRecords = [];
      this.checkedRecords = this.$refs.xTable.getCheckboxRecords();  
      if(this.checkedRecords.length === 0){
        message.warn("请至少选择一条记录~")
      }else{
        this.openedText = this.checkedRecords.length;
        this.opened = true;
      }
      console.log(this.checkedRecords)
    },
    printList(){
      const $table = this.$refs.xTable
      let columns = [
        { field: 'code' },
        { field: 'assetsTypeName' },
        { field: 'name' },
        { field: 'specification' },
        { field: 'startDate' },
        { field: 'originalValue' },
        { field: 'currentDepreciation' },
        { field: 'netValue' },
      ];
      if(this.showAll){
        columns = [
          { field: 'code'},
          { field: 'assetsTypeName'},
          { field: 'name'},
          { field: 'deptName'},
          { field: 'supplier'},
          { field: 'specification'},
          { field: 'startDate'},
          { field: 'originalValue'},
          { field: 'currentDepreciation'},
          { field: 'netValue'},
          { field: 'addTypeVal'},
        ];
      }
      if ($table) {
        $table.print({
          // sheetName: '固定资产列表',
          // // 打印样式设置
          // style: printStyle,
          // 打印指定列
          columns,
        })
      }
    },
    onPageChange() {
      this.loadList();
    },
    doSearch() {
      this.pagination.page = 1;
      this.loadList();
    },
    loadList() {
      this.loading = true
      Assets.list(Object.assign({}, this.params, this.pagination)).then(({data}) => {
        this.dataList = data.results || [];
        this.pagination.total = data.total;
      }).finally(() => this.loading = false)
      if (this.$refs.assetsParamsDropdown) {
        this.$refs.assetsParamsDropdown.hide()
      }
    },
    initSelect() {
      setting.accountingCategoryDetails.loadAuxiliaryAccountingDataByName(['DEPARTMENT', 'VENDOR']).then(({data}) => {
        this.deptList = data['DEPARTMENT'].map(val => {
          return {
            key: val.id,
            accountingCategoryId: val.categoryId,
            title: val.name
          }
        });
        this.supplierList = data['VENDOR'].map(val => {
          return {
            key: val.id,
            accountingCategoryId: val.accountingCategoryId,
            title: val.name
          }
        });
      })
      AssetsType.list().then(({data}) => {
        console.log(data)
        this.assetsTypeList = data || [];
      })
      Setting.subject.voucherSelect().then(({data}) => {
        this.subjectList = data || [];
      })
    },
    copyAssets() {
      let records = this.$refs.xTable.getCheckboxRecords().map(row => row.id);
      if (records.length) {
        this.loading = true;
        Assets.copy(records).then(() => {
          this.loadList();
        }).finally(() => this.loading = false)
      } else {
        message.warn("请至少选择一条记录~")
      }
    },
    removeCheckbox() {
      //删除资产
      let records = this.$refs.xTable.getCheckboxRecords().map(row => row.id);
      let recodrss = this.$refs.xTable.getCheckboxRecords();
      let list = [];
      recodrss.forEach(item => {
        if(item.entryDate != this.checkDataList[0].key){
          let str = item.code + '-' + item.name;
          list.push(str);
        }
      })
      if(list.length > 0){
        let msg = '';
        list.forEach(item => {
          msg += item + '|';
        })
        message.warn(`资产${msg}期间已经结账，不可删除！`)
      }else{
        if (records.length && recodrss.every(val => !val.isVoucher)) {
          confirm({
            content: `确认删除这些记录?`,
            onConfirm: () => {
              this.loading = true;
              Assets.batchDelete(records).then(() => {
                this.loadList();
              }).finally(() => this.loading = false)
            }
          })
        }else if(!recodrss.every(val => !val.isVoucher)){
          let msgText = '';
          recodrss.forEach(item =>{
            if(item.isVoucher){
              msgText += item.code + '-' + item.name + "|";
            }
          })
          message.warn(`资产${msgText}已经生成凭证，请重新选择或删除凭证后再试！`)
        } else {
          message.warn("请至少选择一条记录~")
        }
      }
    },
    showForm(entity = null) {
      let layerId = layer.drawer({
        title: "固定资产信息",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['1000px', '100vh'],
        content: h(AssetsForm, {
          entity,
          nextCode: this.nextCode,
          assetsTypeList: this.assetsTypeList,
          deptList: this.deptList,
          supplierList: this.supplierList,
          subjectList: this.subjectList,
          checkDate: this.checkDataList[0],
          onClose: () => {
            layer.close(layerId);
            this.initSelect();
          },
          onSuccess: () => {
            this.loadList();
            this.initSelect();
            layer.close(layerId);
          }
        })
      });
    },
    showChangeForm(entity = null) {
      let layerId = layer.open({
        title: "变更资产信息",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['600px', 'auto'],
        content: h(AssetsChangeForm, {
          entity, subjectList: this.subjectList, deptList: this.deptList,
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            this.loadList();
            layer.close(layerId);
          }
        })
      });
    },
    remove(row) {
      this.$Confirm("确认删除?").then(() => {
        this.loading = true;
        Assets.delete(row.id).then(() => {
          this.loadList();
        }).finally(() => this.loading = true)
      })
    },
    reset() {
      Object.keys(this.params).forEach(key => this.params[key] = null)
      this.params.entryDate = this.checkDataList[0].key;
      this.loadList();
    },
    showDetail(row) {
      layer.drawer({
        title: "资产信息",
        zIndex: 1000,
        area: ['80vw', '100vh'],
        content: h(AssetsView, {
          assets: row,deptList:this.deptList
        })
      });
    },
    dispose(code, row) {
      confirm({
        title: "操作提示",
        content: "确定进行此操作吗?",
        async: true,
        onConfirm: (resolve) => {
          Assets.dispose(row.id, code).then(() => {
            resolve(true);
            this.loadList();
          }).catch(() => resolve(false))
        }
      })
    },
    exportAssets() {
      let layerId = layer.open({
        title: "资产导入",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['500px', 'auto'],
        content: h(AssetsImport, {
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            this.loadList();
            layer.close(layerId);
          }
        })
      });
    }
  },
  created() {
    this.initSelect();
    Assets.checkDate().then(({data}) => {
      this.checkDataList = data;
      this.params.entryDate = data[0].key;
      this.loadList();
    })
  }
}
</script>
<script setup>
import manba from 'manba'
</script>
